'use client';

import TestimonialsColumn from './TestimonialsColumn';

/* Testimonials — a light section that slides up OVER the still-sticky
   "Our Process" (ProductJourney) section via a negative-margin parallax
   (mirrors how TrustSection slides over the hero). Replaces the old white
   clip-path expansion that used to live inside ProductJourney. */

const testimonials = [
  { text: 'They delivered an exceptional OTT application, showcasing technical expertise and customer-centricity. Their deep understanding of OTT technology, seamless integration of trends and reliable functionality exceeded expectations. I wholeheartedly recommend their services.', name: 'William A. Mobley, Jr.', company: 'Freecast' },
  { text: 'Bleachsecurity delivers next-generation cybersecurity solutions, protecting businesses against evolving threats with advanced monitoring, automation and AI-driven threat intelligence.', name: 'Sarah Williams', company: 'Bleachsecurity' },
  { text: 'Cloudastra Technologies develops digital education solutions that have transformed professional training at ICSI (Institute of Company Secretaries of India). Their platform improves the learning experience and resource accessibility for company secretary students while making administrative processes more efficient.', name: 'Rohan Mehta', company: 'ICSI' },
  { text: 'Altcase empowers global investors with innovative fintech solutions, simplifying portfolio management, providing real-time analytics and enabling data-driven decision-making.', name: 'Madhusudhan ML', company: 'Altcase' },
  { text: 'They revolutionized our insurance services with an AI-based bot, streamlining customer interactions and significantly reducing costs. Their tailored solution efficiently handles claims, improving operational efficiency and enhancing the overall customer experience.', name: 'Corey Kuwanoe', company: 'Politech' },
  { text: 'Cloudastra Technologies has elevated home interiors with their AI-based application, predicting ideal designs. Their innovative tool streamlined decision-making, adding a delightful, creative dimension to home transformations, enhancing personalization for an unparalleled experience.', name: 'Castleigh Johnson', company: 'MHP' },
  { text: "Cloudastra's Nigmat Bot revolutionized our B2B operations with next-gen AI technology. Its versatility and cost savings were remarkable. The beta version, handled with dedication, showcased Cloudastra's commitment to client success.", name: 'Mike Futch', company: 'Tompkins' },
];

const firstColumn = testimonials.slice(0, 3);
const secondColumn = testimonials.slice(3, 5);
const thirdColumn = testimonials.slice(5, 7);

export default function Testimonials() {
  return (
    <section
      data-nav-theme="light"
      className="relative z-20 -mt-[150vh] overflow-hidden max-[880px]:mt-0 rounded-t-[2.5rem] bg-white py-20 lg:py-28"
    >
      <div className="mx-auto w-11/12 max-w-[1280px]">
        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#058BF0] sm:text-sm">
            Testimonials
          </p>
          <h2 className="mx-auto mt-5 max-w-3xl font-poppins text-3xl font-bold leading-[1.2] sm:leading-[1.2] lg:leading-[1.2] tracking-tight text-[#0a1b3a] sm:text-4xl lg:text-5xl xl:text-[3.25rem]">
            What our clients say
          </h2>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-gray-600 lg:text-lg">
            See what our customers have to say about working with Cloudastra.
          </p>
        </div>

        <div className="mt-10 flex max-h-[58vh] justify-center gap-6 overflow-hidden [mask-image:linear-gradient(to_bottom,transparent,black_25%,black_75%,transparent)]">
          <TestimonialsColumn testimonials={firstColumn} duration={22} />
          <TestimonialsColumn testimonials={secondColumn} className="hidden md:block" duration={26} />
          <TestimonialsColumn testimonials={thirdColumn} className="hidden lg:block" duration={24} />
        </div>
      </div>
    </section>
  );
}
